module.exports = __webpack_public_path__ + "img/i002.71374e08.png";